import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    Col, Row, Card, CardBody, Button, Collapse
} from 'reactstrap';
import { Field, reduxForm, FormSection, SubmissionError, FieldArray } from 'redux-form'
import DropDownSelect from '../Dropdown/index';
import { checkSubmitError, checkZeroValue, checkOne } from '../helper'
const renderMembers = ({ fields, riskLevels, meta: { error, submitFailed } }) => (
    <ul>
        {fields.map((member, index) => (
            <li key={index}>
                <Row className="d-flex align-items-center mb-3">
                    <Col sm="4" className="px-2">
                        <div className="d-flex align-items-center text-secondary border radius-5 p-2">
                            <Field
                                type="number"
                                name={`${member}.minScore`}
                                component="input"
                                className="w-45 border-0 radius-5 risk-grade-input"
                                placeholder="min" />
                            <span className="d-inline-block mr-2 border-right">&nbsp;</span>
                            <Field type="number"
                                component="input"
                                className="w-45 border-0 radius-5 risk-grade-input"
                                placeholder="max"
                                name={`${member}.maxScore`} />
                        </div>
                    </Col>
                    <Col sm="4" className="px-2">
                        <div>
                            <Field
                                component="input"
                                name={`${member}.riskGrade`}
                                type="text"
                                placeholder="Grades"
                                className="p-2 w-100 radius-5 border risk-grade-input" />
                        </div>
                    </Col>
                    <Col sm="4" className="px-2">
                        <div className="border dropdown-counterparty riskgrade-category-dd">
                            <Field
                                name={`${member}.riskLevel`}
                                type="text"
                                component={DropDownSelect}
                                label="State"
                                data={riskLevels}
                            >

                            </Field>
                        </div>
                    </Col>
                    <Col sm="7" className="px-2">
                        <div className="">
                            <Field type="text"
                                name={`${member}.gradeDescription`}
                                component="input"
                                placeholder="Grade Description"
                                className="p-2 w-100 radius-5 border risk-grade-input" />
                        </div>
                    </Col>
                    <Col sm="3" className="px-2">
                        <div className="">
                            <Field type="number"
                                name={`${member}.pd`}
                                component="input"
                                placeholder="00"
                                className="p-2 w-100 radius-5 border risk-grade-input" />
                        </div>
                    </Col>
                    <Col sm="2" className="px-2 text-right"><a onClick={() => fields.remove(index)}><i className="icon-close text-danger pointer"></i></a> </Col>
                </Row>
            </li>
        ))}
        <Row>
            <Button type="button" className="d-flex ml-auto text-primary text-decoration-none pr-0" color="link" onClick={() => fields.push({})}><i className="icon-plus mr-2 text-decoration-none"></i>Add More</Button>
        </Row>

    </ul>
)



class ScorecardSetupForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            toggleFinancialRiskCollapse: true,
            toggleNonFinancialRiskCollapse: false,
            toggleRiskGradesCollapse: false,
            nonfinancialBody: "",
            financialBody: "",
        };
        this.count = 2;
    }



    componentDidMount = () => {
        if (this.props.editdata) {
            this.props.initialize(this.props.editdata)
        }
        else {
            this.props.initialize({
                "riskGrades": [
                    {
                      "minScore": 0,
                      "maxScore": 30,
                      "riskGrade": "Rx8",
                      "gradeDescription": "Highest Counterparty Risk",
                      "pd": 80,
                      "riskLevel": "HIGH"
                    },
                    {
                      "minScore": 30,
                      "maxScore": 40,
                      "riskGrade": "Rx7",
                      "gradeDescription": "Very High Counterparty Risk",
                      "pd": 70,
                      "riskLevel": "HIGH"
                    },
                    {
                      "minScore": 40,
                      "maxScore": 50,
                      "riskGrade": "Rx6",
                      "gradeDescription": "High Counterparty Risk",
                      "pd": 60,
                      "riskLevel": "HIGH"
                    },
                    {
                      "minScore": 50,
                      "maxScore": 60,
                      "riskGrade": "Rx5",
                      "gradeDescription": "Above Average Counterparty Risk",
                      "pd": 50,
                      "riskLevel": "MEDIUM"
                    },
                    {
                      "minScore": 60,
                      "maxScore": 70,
                      "riskGrade": "Rx4",
                      "gradeDescription": "Average Counterparty Risk",
                      "pd": 40,
                      "riskLevel": "MEDIUM"
                    },
                    {
                      "minScore": 70,
                      "maxScore": 80,
                      "riskGrade": "Rx3",
                      "gradeDescription": "Below Average Counterparty Risk",
                      "pd": 30,
                      "riskLevel": "LOW"
                    },
                    {
                      "minScore": 80,
                      "maxScore": 90,
                      "riskGrade": "Rx2",
                      "gradeDescription": "Low Counterparty Risk",
                      "pd": 20,
                      "riskLevel": "LOW"
                    },
                    {
                      "minScore": 90,
                      "maxScore": 100,
                      "riskGrade": "Rx1",
                      "gradeDescription": "Lowest Counterparty Risk",
                      "pd": 10,
                      "riskLevel": "LOW"
                    }
                  ]
            })
        }

    }

    componentDidUpdate(prevProps) {


    }
    toggleFinancialRiskCollapse = () => {
        this.setState({ toggleFinancialRiskCollapse: !this.state.toggleFinancialRiskCollapse });
    }

    toggleNonFinancialRiskCollapse = () => {
        this.setState({ toggleNonFinancialRiskCollapse: !this.state.toggleNonFinancialRiskCollapse });
    }

    toggleRiskGradesCollapse = () => {
        this.setState({ toggleRiskGradesCollapse: !this.state.toggleRiskGradesCollapse });
    }

    mySubmitScorecard = (values) => {
        const { reset } = this.props
        if (checkOne(values.riskGrades)) {
            throw new SubmissionError({
                _error: 'There should be atleast one Riskgrade',
            });
        } else if (checkSubmitError(values.riskGrades)) {
            throw new SubmissionError({
                _error: 'All the fields of Riskgrade should be filled',
            });
        } else if (!values.financialRiskFactorList && !values.nonFinancialRiskFactorList) {
            throw new SubmissionError({
                _error: '"At least one financial or nonfiancial riskfactor should be Non zero"',
            });

        } else {
            this.props.toggle()
            reset();
            this.props.saveData(checkZeroValue(values))
        }



    }

    handleCancel = () => {
        this.props.toggle()
        this.props.cancel()
    }

    sortFactors = (a, b) => {
        var x = a.name; var y = b.name;
        if (a.enabled && b.enabled) {
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        }
        else if (a.enabled && b.enabled === false) {
            return -1;
        }
        else if (b.enabled && a.enabled === false) {
            return 1;
        }
    }


    render() {
        let financialFactors
        let nonFinancialFactors
        const { error, handleSubmit, riskfactors } = this.props
        if (riskfactors && riskfactors.financialFactors && riskfactors.nonFinancialFactors) {
            riskfactors.financialFactors.sort(this.sortFactors);
            riskfactors.nonFinancialFactors.sort(this.sortFactors);

            financialFactors = riskfactors.financialFactors.map(p => {
                return (
                    <li className="col-sm-8 d-flex select-risk-factor py-3" key={p.name}>
                        <div className="d-flex risk-factor-details">
                            <label title={p.name} className="d-inline-block w-75 px-3 py-2 risk-factor-name text-truncate">{p.name}</label>
                            <Field
                                name={p.id}
                                component="input"
                                type="number"
                                placeholder="00"
                                className="w-25 p-1 text-center risk-factor-weight"
                                disabled={p.enabled ? "" : "disabled"}
                            />
                        </div>
                    </li>
                )
            })
            nonFinancialFactors = riskfactors.nonFinancialFactors.map(p => {
                return (
                    <li className="col-sm-8 d-flex select-risk-factor py-3" key={p.name}>
                        <div className="d-flex risk-factor-details">
                            <label title={p.name} className="d-inline-block w-75 px-3 py-2 risk-factor-name text-truncate">{p.name}</label>
                            <Field
                                name={p.id}
                                component="input"
                                type="number"
                                placeholder="00"
                                className="w-25 p-1 text-center risk-factor-weight"
                                disabled={p.enabled ? "" : "disabled"}
                            />

                        </div>
                    </li>
                )
            })
        }
        return (
            <form onSubmit={handleSubmit((val) => { this.mySubmitScorecard(val) })}>
                <section className="mb-4">
                    <div className="header-blue p-3 d-flex justify-content-between align-items-center" onClick={this.toggleFinancialRiskCollapse}>
                        <span className="text-primary">Quantitative Risk Factors</span>
                        <i className={this.state.toggleFinancialRiskCollapse ? "icon-arrow-up" : "icon-arrow-down"}></i>
                    </div>
                    <Collapse isOpen={this.state.toggleFinancialRiskCollapse}>
                        <Card className="shadow-none">
                            <CardBody className="py-0">
                                <FormSection name="financialRiskFactorList">
                                    <ul className="row mb-0">
                                        {/* {this.state.financialBody} */}
                                        {financialFactors}
                                    </ul>
                                </FormSection>
                            </CardBody>
                        </Card>
                    </Collapse>
                </section>
                <section className="mb-4">
                    <div className="header-blue p-3 d-flex justify-content-between align-items-center" onClick={this.toggleNonFinancialRiskCollapse}>
                        <span className="text-primary">Qualitative Risk Factors</span>
                        <i className={this.state.toggleNonFinancialRiskCollapse ? "icon-arrow-up" : "icon-arrow-down"}></i>
                    </div>
                    <Collapse isOpen={this.state.toggleNonFinancialRiskCollapse}>
                        <Card className="shadow-none">
                            <CardBody className="pt-0">
                                <FormSection name="nonFinancialRiskFactorList">
                                    <ul className="row mb-0">
                                        {/* {this.state.nonfinancialBody} */}
                                        {nonFinancialFactors}
                                    </ul>
                                </FormSection>
                            </CardBody>
                        </Card>
                    </Collapse>
                </section>
                <section className="mb-4">
                    <div className="header-blue p-3 d-flex justify-content-between align-items-center" onClick={this.toggleRiskGradesCollapse}>
                        <span className="text-primary">Risk Grades</span>
                        <i className={this.state.toggleRiskGradesCollapse ? "icon-arrow-up" : "icon-arrow-down"}></i>
                    </div>
                    <Collapse isOpen={this.state.toggleRiskGradesCollapse}>
                        <Card className="shadow-none">
                            <CardBody>
                                <Row className="mb-1">
                                    <Col sm="4" className="px-2">Range</Col>
                                    <Col sm="4" className="px-2">Grades</Col>
                                    <Col sm="4" className="px-2">Category</Col>
                                    <Col sm="7" className="px-2">Grade Description</Col>
                                    <Col sm="3" className="px-2">PD</Col>
                                    <Col sm="2" className="px-2"></Col>
                                </Row>
                                <FieldArray name="riskGrades" component={renderMembers} riskLevels={this.props.riskLevels} />
                                {/* <FieldArray name="members" fields={this.state.riskGradeBody} component={renderMembers} riskLevels={this.props.riskLevels}/> */}

                            </CardBody>

                        </Card>
                    </Collapse>

                    <strong className='text-danger mb-5'>{error ? error : ""}</strong>
                </section>

                <div>
                    <button type="submit" className="btn btn-info">
                        Submit
          </button>
                    <button type="button" className="btn btn-danger ml-3" onClick={this.handleCancel}>
                        Cancel
          </button>

                </div>
            </form>
        )
    }
}


const mapStateToProps = (state, ownProps) => ({
    // editdata: state.corporateOnBoardingCreate.editData
})

const mapDispatchToProps = (dispatch, ownProps) => ({
})

export default reduxForm({
    form: 'ScorecardSetupForm'
})(connect(mapStateToProps, mapDispatchToProps)(ScorecardSetupForm))
